import React, { useState, useEffect, useCallback } from "react";
import { stripHtml } from "../../utils/util-functions/stripHTML";
import { stripText } from "../../utils/util-functions/stripText";
import { Button } from "../../components/ui/button";
import { Link } from "react-router-dom";
import {
  DialogFeedback,
  DialogTriggerFeedback,
  DialogContentFeedback,
  DialogHeaderFeedback,
  DialogTitleFeedback,
  DialogDescriptionFeedback,
} from "../../components/ui/dialog-feedback";
import { ScrollArea } from "../../components/ui/scroll-area";

const StudentFeedbackCard = ({ student_name, student_pic,enrolled_date, student_feedback, selected_year, qualified_exam, enrolled_batch,starts_on }) => {
  const [innerWidth, setInnerWidth] = useState(window.innerWidth);
  const [showReadMore, setShowReadMore] = useState(false);

  // Handle resizing the window
  useEffect(() => {
    const handleResize = () => setInnerWidth(window.innerWidth);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const getReadMoreData = useCallback(() => {
    return (
      <DialogFeedback>
        <DialogTriggerFeedback asChild>
          <Link to="#"><span className="text-[#fff] text-[14px]">Read More</span></Link>
        </DialogTriggerFeedback>
        <DialogContentFeedback className="sm:max-w-[36rem] w-[95%] h-[70vh] lg:max-w-[36rem]">
          <DialogHeaderFeedback>
            <div className="grid grid-cols-2 gap-2">
              <div
                style={{
                  aspectRatio: "1",
                  borderRadius: "50%",
                  backgroundImage: `url('${student_pic}')`,
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                  backgroundSize: "cover",
                }}
                className="bg-white absolute top-[8px]  md:w-[94px] w-[100px] z-10  border-4 border-white shadow-[0_8px_16px_rgba(107,114,128,0.3)]"
              >
              </div>
              <DialogTitleFeedback>{student_name}</DialogTitleFeedback>
            </div>
            <br />

            <br />
            <DialogDescriptionFeedback>
              <hr className="mt-5" />
              <ScrollArea className="lg:w-full lg:h-auto p-1 rounded-md">
                <div className="mt-2">
                  <div className="grid grid-cols-2 gap-2">
                    <div className="font-bold text-left">Enrolled Batch:</div>
                    <div className="pl-2 text-left">{enrolled_batch ?? "--"}</div>
                  </div>
                  <div className="grid grid-cols-2 gap-2">
                    <div className="font-bold text-left">Enrolled Date:</div>
                    <div className="pl-2 text-left">{enrolled_date ?? "--"}</div>
                  </div>
                  <div className="grid grid-cols-2 gap-2">
                    <div className="font-bold text-left">Qualified Exam:</div>
                    <div className="pl-2 text-left">{qualified_exam ?? "--"}</div>
                  </div>
                  <div className="grid grid-cols-2 gap-2">
                    <div className="font-bold text-left">Selected Year:</div>
                    <div className="pl-2 text-left">{selected_year ?? "--"}</div>
                  </div>
                </div>
                <div className="mt-6 text-justify overflow-y-scroll max-h-[273px]">{stripHtml(student_feedback)}</div>
              </ScrollArea>
            </DialogDescriptionFeedback>
          </DialogHeaderFeedback>
        </DialogContentFeedback>
      </DialogFeedback>
    );
  }, [student_name, student_feedback]);

  // Memoized feedback data to avoid unnecessary re-renders
  const feedbackData = useCallback(() => {
    const data = stripText(stripHtml(student_feedback), 100, { returnTextsLengths: true });
    const { plainText, plainTextLength, stripedTextLength } = data;

    // Only update state if necessary to avoid infinite loop
    if (plainTextLength > stripedTextLength && !showReadMore) {
      setShowReadMore(true); // Update state only if required
    }

    return plainText;
  }, [student_feedback, showReadMore]); // Add showReadMore as a dependency

  return (
    <div className="my-0 border border-[#c1c1c1] rounded-[16px] p-2 md:p-4 bg-white shadow-lg w-full">
      <div className="flex flex-col lg:flex-row gap-2 md:gap-4">
        {/* Hexagon div */}
        <div
          style={{
            aspectRatio: "1",
            borderRadius: "50%",
            backgroundImage: `url('${student_pic}')`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundSize: "cover",
          }}
          className={`md:w-[150px] m-auto lg:m-0 w-[150px] h-[150px] flex items-center justify-center z-10 border-4 border-white ${
    student_pic ? "" : "bg-gray-200 text-gray-600 font-semibold"
  }`}
        >
        </div>

        {/* details section  */}
        <div className="p-2 lg:text-[1rem] text-sm flex flex-col justify-start">
          <div className="">
            <div className="grid grid-cols-2 gap-2">
              <div className="font-bold">Name:</div>
              <div className="pl-2">{student_name}</div>
            </div>
            <div className="grid grid-cols-2 gap-2">
              <div className="font-bold">Enrolled Batch:</div>
              <div className="pl-2">{enrolled_batch || "--"}</div>
            </div>
            <div className="grid grid-cols-2 gap-2">
              <div className="font-bold">Enrolled Date:</div>
              <div className="pl-2">{starts_on}</div>
            </div>
            <div className="grid grid-cols-2 gap-2">
              <div className="font-bold">Qualified Exam:</div>
              <div className="pl-2">{qualified_exam}</div>
            </div>
            <div className="grid grid-cols-2 gap-2">
              <div className="font-bold">Selected Year:</div>
              <div className="pl-2">{selected_year}</div>
            </div>
            
            
            
          </div>
        </div>
      </div>
      
      <div className="border-t border-[#DFE3EC] mt-4 pt-2">
        <div className="col-span-1 md:col-span-2 ">
               {feedbackData()}
               
  {showReadMore && <span className="float-right mt-3 inline-block px-5 py-1 text-l font-bold text-white bg-gradient-to-r from-cyan-400 to-purple-600 rounded-full shadow-lg hover:shadow-2xl transition-all">{getReadMoreData()}</span>}

        </div>
      </div>
    </div>
  );
};

export default StudentFeedbackCard;
